
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SequenceGraphQL"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SequenceNode"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegistryItemGraphQL"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"analysesJson"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"annotationsJson"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"assemblyJson"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bases"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"circular"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"color"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"creator"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"handle"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"finalized"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fragmentResultsJson"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasSnapshot"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isContainedInComplexPolymerData"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isContained"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"latestVersionId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"length"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"locked"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"modifiedNucleotides"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ModifiedNucleotideGraphQL"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"noteJson"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nucleotideType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"parentJson"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"partsJson"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"primerPairsJson"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sequencePrimersJson"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sequenceType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"snapshotUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"startIndex"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"translationGroupsJson"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"translationsJson"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"versionsJson"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"versionsWereTruncated"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":614}};
    doc.loc.source = {"body":"fragment SequenceGraphQL on SequenceNode {\n  ...RegistryItemGraphQL\n  analysesJson\n  annotationsJson\n  assemblyJson\n  bases\n  circular\n  color\n  creator {\n    id\n    handle\n  }\n  finalized\n  fragmentResultsJson\n  hasSnapshot\n  isContainedInComplexPolymerData {\n    isContained\n    errorMessage\n  }\n  latestVersionId\n  length\n  locked\n  modifiedNucleotides {\n    ...ModifiedNucleotideGraphQL\n  }\n  noteJson\n  nucleotideType\n  parentJson\n  partsJson\n  primerPairsJson\n  sequencePrimersJson\n  sequenceType\n  snapshotUrl\n  startIndex\n  translationGroupsJson\n  translationsJson\n  versionsJson\n  versionsWereTruncated\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["SequenceGraphQL"] = oneQuery(doc, "SequenceGraphQL");
        
